
export const MODAL_COMPONENT = `MODAL_COMPONENT`;
export const MODAL_DATA = `MODAL_DATA`;
export const MODAL_OPTIONS = `MODAL_OPTIONS`;
export const MODAL_REF = `MODAL_REF`;
export const MODAL_COMPONENT_INJECTOR = `MODAL_COMPONENT_INJECTOR`;
